import React from 'react';
import { motion } from 'framer-motion';
import { Moon, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useHealthMetrics } from '../hooks/useHealthMetrics';
import { SleepBreakdown } from '../components/sleep/SleepBreakdown';
import { SleepAnalysisSummary } from '../components/sleep/SleepAnalysisSummary';
import { SleepKnowledge } from '../components/sleep/SleepKnowledge';

export function SleepPage() {
  const navigate = useNavigate();
  const metrics = useHealthMetrics();

  return (
    <div className="fixed inset-0 bg-background/95 backdrop-blur-xl z-[100] overflow-y-auto">
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="relative">
              <Moon className="w-6 h-6 text-primary" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
            <div>
              <h2 className="text-xl font-semibold">Sleep Analysis</h2>
              <p className="text-sm text-muted-foreground">Track and optimize your sleep</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/home')}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-6">
          <SleepAnalysisSummary
            sleepScore={metrics.sleep.score}
            previousScore={metrics.sleep.score - 5}
            insights={[]}
          />
          <SleepBreakdown
            sleepStages={{
              rem: 108,
              deep: 98,
              light: 224,
              awake: 20
            }}
          />
          <SleepKnowledge />
        </div>
      </div>
    </div>
  );
}